import { lazy } from 'react';

const routeLoaders = {
  '/about': () => import('./pages/About'),
  '/services': () => import('./pages/Services'),
  '/contact': () => import('./pages/Contact'),
  '/terms': () => import('./pages/Terms'),
  '/privacy': () => import('./pages/Privacy'),
  '/delete-account': () => import('./pages/DeleteAccount'),
};

const loadRoute = (path) => routeLoaders[path]?.() ?? Promise.resolve(null);

export const AboutRoute = lazy(routeLoaders['/about']);
export const ServicesRoute = lazy(routeLoaders['/services']);
export const ContactRoute = lazy(routeLoaders['/contact']);
export const TermsRoute = lazy(routeLoaders['/terms']);
export const PrivacyRoute = lazy(routeLoaders['/privacy']);
export const DeleteAccountRoute = lazy(routeLoaders['/delete-account']);

export function preloadRoute(path) {
  return loadRoute(path);
}

export function preloadNonCriticalRoutes() {
  Object.keys(routeLoaders).forEach((path) => {
    loadRoute(path);
  });
}
